import { Stack, Tabs } from '@mantine/core'
import { useQueryParamTab } from 'src/utils/tabQueryParam'
import TutorPage from './TutorPage'
import { FindMyTutorCmsType } from 'src/apis/findMyTutorAPI'
import TutorCountryPage from './TutorCountryPage'

const TAB_OPTIONS: Array<{ label: string; value: FindMyTutorCmsType | 'country' }> = [
	{ label: 'Tutor', value: 'tutor' },
	{ label: 'Learner', value: 'learner' },
	{ label: 'Course', value: 'course' },
	{ label: 'Post', value: 'post' },
	{ label: 'Country', value: 'country' },
]

function FindMyTutorPage() {
	const tabValues = TAB_OPTIONS.map((option) => option.value)
	const { activeTab, handleTabChange } = useQueryParamTab(tabValues, 'tutor')

	return (
		<Stack sx={{ width: '100%' }}>
			<Tabs value={activeTab} onTabChange={handleTabChange} keepMounted={false}>
				<Tabs.List>
					{TAB_OPTIONS.map((option) => (
						<Tabs.Tab key={option.value} value={option.value} fw={700}>
							{option.label}
						</Tabs.Tab>
					))}
				</Tabs.List>

				{TAB_OPTIONS.map((option) => (
					<Tabs.Panel key={option.value} value={option.value} pt="md">
						{option.value === 'country' ? (
							<TutorCountryPage />
						) : (
							<TutorPage type={option.value} />
						)}
					</Tabs.Panel>
				))}
			</Tabs>
		</Stack>
	)
}

export default FindMyTutorPage
